// Title: Extent of metering of water connections

import React, { useCallback, useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';

import FeeCreateForm from './FeeCreateForm';

const { PRIVATE_ROUTE } = API_ROUTES;

function FeeForm() {
  const {id} = useParams();
  const { authAxios } = useContext(FetchContext);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isSubmitting },
    setValue,
    control
  } = useForm({
    defaultValues: {
      name: '',
      percentage: '',
    }});

  const getFeeFormById = useCallback(async () => {
    const  {data}  = await authAxios.get(
      `${PRIVATE_ROUTE.GET_FEE_BY_ID}/${id}`
    );

    setValue('name', data?.data.name);
    setValue('percentage',data?.data?.percentage);
  }, [authAxios, id, setValue]);
  useEffect(() => {
    if (id) {
      getFeeFormById();
    }
  }, [getFeeFormById, id]);

  const onSubmit = async (data) => {
     if (id) {
      const response = await authAxios.post(
        `${PRIVATE_ROUTE?.EDIT_FEE}${id}`,
        data
      );
      toast.success(response.data.massage);
      navigate('/master/fee/list');
    } else {
      const response = await authAxios.post(PRIVATE_ROUTE?.CREATE_FEE, data);
  
      if (response.data.statusCode === 200) {
        toast.success(response.data.massage);
        navigate('/master/fee/list');
      }
      else {
        toast.error(response.data.massage);
      }
    }
    setValue('name', '');
    setValue('percentage', '');
  };
  return (
    <FeeCreateForm
      register={register}
      setValue={setValue}
      getValues={getValues}
      handleSubmit={handleSubmit}
      errors={errors}
      onSubmit={onSubmit}
      params={id}
      loading={isSubmitting}
      isEdit={id?"true":"false"}
      control={control}
    />
  );
}

export default FeeForm;
